import { z } from "zod";

export const VendorWithLast12Schema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  createdAt: z.preprocess(
    (value) => (value instanceof Date ? new Date(value).toISOString() : value),
    z.string(),
  ),
  externalPointOfContact: z.string().nullable(),
  externalSigner: z.string().nullable(),
  last12Spend: z.number().nullable(),
  next12ServiceSpend: z.number().nullable(),
  connectedCategories: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  connectedDepartments: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  ownedDocuments: z.number(),
  ownedServices: z.number(),
  owners: z.array(
    z.object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      departments: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
        }),
      ),
    }),
  ),
  signer: z
    .object({
      email: z.string(),
    })
    .nullable(),
  paymentMethod: z.string(),
  hasErpVendors: z.boolean(),
  archived: z.boolean(),
  customColumns: z.array(
    z.object({
      id: z.string(),
      display: z.string(),
      ordinal: z.number(),
      value: z.string().nullable(),
    }),
  ),
});
